export default __webpack_public_path__ + "resources/icons/n421-abad.png";